<template>
  <div class="related-diseases">
    <module-header title="相关病症" icon="icon-diseases" :showMore="false"></module-header>
    <!-- {{ list }} -->
    <div class="list">
      <el-scrollbar style="height: 100%" v-loading="loading">
        <div class="item" v-for="(item, index) of list" :key="'diseases' + index" @click="go2detail(item)">
          {{ item.Name }}
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '../common/ArtHeaderLeft';
export default {
  name: 'RelatedDiseases',
  components: { ModuleHeader },
  props: {
    params: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      map: {},
      loading: true,
    };
  },
  computed: {
    list() {
      const { Name } = this.$store.getters['app/departmentsMap'][this.params.CategoryId] || {};
      return (this.map[Name] || {}).TreatmentGuideline || [];
    },
  },
  created() {
    this.$apis.disease.getSpecialtyDisease().then(res => {
      this.map = res.map;
      this.loading = false;
    });
  },
  methods: {
    go2detail(item) {
      location.assign(
        `${this.$constants.routers.disease.link}?Name=${encodeURIComponent(item.Name)}&CategoryType=${
          this.params.CategoryType
        }&CategoryId=${this.params.CategoryId}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/css/variables.scss';
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.related-diseases {
  .page-component__scroll .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .el-scrollbar__thumb {
    background: $theme-red;
  }
  .list {
    /*height: 545px;*/
    /*padding: 20px 13px;*/
    @include padding-height(66%);
    padding-left: 20px;
    overflow-x: auto;
    .item {
      font-size: 14px;
      color: $font-main;
      line-height: 2;
      cursor: pointer;
    }
  }
}
</style>
